import { Theme } from './theme'

export default function getValueFromTheme(color: Theme, def?: string) {
  const root = document.documentElement
  if (root) {
    return root.style.getPropertyValue(`--${color}`) || def
  }
}
